import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
import { passFailState, passFailMutations } from '@/../../troubleshooter/src/store/common/passFail'

export default {
  namespaced: true,
  state: {
    ...passFailState,
    explainer: [
      _('Now we have to check that you\'re actually able to connect to the virtual classroom over the internet.'),
      _('The better the connection, the better the audio and video quality.'),
      _('How fast is your connection?')
    ],
    title: _('Step 4: Test Your Internet Connection'),
    nextPage: '#/preview/',
    previousPage: '#/camera/',
    callToAction: {
      'text': _('Speed Test')
    },
    questionId: 'connection'
  },

  mutations: {
    ...passFailMutations
  },

  actions: {
  },

  getters: {
  }
}
